import { render, staticRenderFns } from "./Solicitud.vue?vue&type=template&id=3267f6a4"
import script from "./Solicitud.vue?vue&type=script&lang=js"
export * from "./Solicitud.vue?vue&type=script&lang=js"
import style0 from "./Solicitud.vue?vue&type=style&index=0&id=3267f6a4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports